import * as actions from 'actions';
import textEditingMaker from 'reducersMakers/textEditingMaker';

export default textEditingMaker({
  submitType: actions.MAIL_MESSAGE_THE_TEAM,
  submitSuccessType: actions.MAIL_MESSAGE_THE_TEAM_SUCCESS,
  submitErrorType: actions.MAIL_MESSAGE_THE_TEAM_ERROR,
  updateTextType: actions.MAIL_MESSAGE_THE_TEAM_EDITING_UPDATE_TEXT,
  resetType: actions.MAIL_MESSAGE_THE_TEAM_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/textEditing/teamMessage/reducer.js
 **/